module.exports = __webpack_public_path__ + "static/011-02331639702916510d2807c4db61623b.png";